import {
  ALL_CHART_TYPES,
  IS_STACKED_BAR_HORIZONTAL_SCREENSHOT
} from "constants/chart.constants";
import getChartTypeLabelFromId from "utils/chart/getChartTypeLabelFromId";

import { UserEventContext } from "api/userEvents";

import { IScreenshotSettings } from "models/screenshot";

import { WidgetContextExtractor } from "components/screenshot/utils/widgetContextExtractors";

/**
 * Chart-specific context extractor for screenshot events
 * Extracts relevant chart information like chart type, axes, grouping, etc.
 */
export class ChartContextExtractor implements WidgetContextExtractor {
  widgetType = "chart";

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  extractContext(widgetState: any, _settings: IScreenshotSettings): UserEventContext {
    const context: UserEventContext = {};

    if (widgetState?.request?.entityKind) {
      context.entityKind = widgetState.request.entityKind;
    }

    if (widgetState?.request?.chartSetting?.chartType) {
      const numericChartType = widgetState.request.chartSetting?.chartType;
      // StackedBarHorizontal reuses StackedBar's wire chartType id, so a
      // plain id lookup always resolves to "Stacked Bar" — check axis shape
      // first, same disambiguation as the screenshot settings hooks.
      const chartType = IS_STACKED_BAR_HORIZONTAL_SCREENSHOT(
        numericChartType,
        widgetState?.options?.yAxis
      )
        ? ALL_CHART_TYPES.StackedBarHorizontal.label
        : getChartTypeLabelFromId(numericChartType);
      if (chartType) {
        context.chartType = chartType;
      }
    }

    if (widgetState?.request?.GroupBy?.property) {
      context.groupBy = widgetState.request.GroupBy.property;
    }

    if (widgetState?.request?.chartSetting?.product) {
      context.product = widgetState.request.chartSetting.product;
    }

    if (widgetState?.request?.chartSetting?.source) {
      context.source = widgetState.request.chartSetting.source;
    }

    if (widgetState?.request?.chartSetting?.timeStep) {
      context.timeStep = widgetState.request.chartSetting.timeStep;
    }

    if (widgetState?.request?.chartSetting?.xVariable?.valueProperty) {
      context.xVariable = widgetState.request.chartSetting.xVariable.valueProperty;
    }

    if (widgetState?.request?.chartSetting?.yVariable?.valueProperty) {
      context.yVariable = widgetState.request.chartSetting.yVariable.valueProperty;
    }

    return context;
  }
}
